import {
  container,
  cardTitle,
  grayColor,
  infoColor,
  blackColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

/**
 * Estilos de la pantalla de registro.
 *
 * Objetivos de esta versión:
 * - eliminar márgenes/alturas rígidas
 * - mejorar el comportamiento responsive del formulario
 * - hacer más cómodos los bloques de checkbox y textos largos
 * - mantener consistencia visual con LoginPageStyles.js
 */
const registerPageStyle = {
  ...customCheckboxRadioSwitch,

  cardTitle: {
    ...cardTitle,
    textAlign: "center",
  },

  /**
   * Contenedor general.
   *
   * Antes:
   * - marginTop: "-5%"
   *
   * Ahora:
   * - margen natural
   * - padding lateral para que nada pegue al borde en móvil
   */
  container: {
    ...container,
    position: "relative",
    zIndex: "3",
    marginTop: 0,
    paddingLeft: "15px",
    paddingRight: "15px",

    "@media (max-width: 960px)": {
      paddingLeft: "12px",
      paddingRight: "12px",
    },

    "@media (max-width: 600px)": {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },

  /**
   * Card principal del registro.
   *
   * Antes:
   * - marginTop: 15vh
   * - marginBottom: 100px
   * - padding demasiado rígido
   *
   * Ahora:
   * - espaciado mucho más controlado
   * - adaptación por breakpoint
   */
  cardSignup: {
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(" +
      hexToRgb(blackColor) +
      ", 0.14), 0 6px 30px 5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.12), 0 8px 10px -5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)",
    marginTop: "48px",
    marginBottom: "48px",
    padding: "32px 0",

    "@media (max-width: 960px)": {
      marginTop: "32px",
      marginBottom: "32px",
      padding: "24px 0",
    },

    "@media (max-width: 600px)": {
      marginTop: "20px",
      marginBottom: "20px",
      padding: "18px 0",
    },
  },

  center: {
    textAlign: "center",
  },

  right: {
    textAlign: "right",
  },

  left: {
    textAlign: "left",
  },

  /**
   * Formulario interior.
   *
   * Antes:
   * - paddingTop: "100" (problemático)
   *
   * Ahora:
   * - padding horizontal adaptable
   * - sin top padding artificial
   */
  form: {
    padding: "0 24px",
    paddingTop: 0,
    position: "relative",

    "@media (max-width: 960px)": {
      padding: "0 18px",
    },

    "@media (max-width: 600px)": {
      padding: "0 12px",
    },
  },

  socialTitle: {
    fontSize: "18px",

    "@media (max-width: 600px)": {
      fontSize: "16px",
    },
  },

  inputAdornment: {
    marginRight: "18px",
    position: "relative",

    "@media (max-width: 600px)": {
      marginRight: "12px",
    },
  },

  inputAdornmentIcon: {
    color: grayColor[6],
  },

  customFormControlClasses: {
    margin: "0 12px",

    "@media (max-width: 600px)": {
      margin: "0 6px",
    },
  },

  /**
   * Bloque checkbox + texto legal.
   * Lo dejamos preparado para textos largos y wraps limpios.
   */
  checkboxLabelControl: {
    margin: 0,
    marginTop: 15,
    alignItems: "flex-start",

    "@media (max-width: 600px)": {
      marginTop: 12,
    },
  },

  checkboxLabel: {
    fontSize: "0.875rem",
    marginLeft: "6px",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
    lineHeight: "1.45",

    "@media (max-width: 600px)": {
      fontSize: "0.8rem",
    },
  },

  createAccText: {
    color: infoColor[4],
  },

  /**
   * Títulos auxiliares que se usan en algunos bloques/textos del registro.
   */
  title: {
    color: "#4f749f",
    fontWeight: 400,
    fontSize: "1.3rem",

    "@media (max-width: 600px)": {
      fontSize: "1.1rem",
    },
  },

  /**
   * Párrafos legales o explicativos.
   */
  paragraph: {
    width: "100%",
    maxWidth: 700,
    margin: "0 auto",
    marginBottom: 10,
    fontSize: "1rem",
    lineHeight: "1.65",
    wordBreak: "break-word",

    "@media (max-width: 600px)": {
      fontSize: "0.95rem",
      lineHeight: "1.55",
    },
  },
};

export default registerPageStyle;